// API utility functions for authentication
export const API_BASE_URL = 'https://www.test.airflics.com';
// export const API_BASE_URL = 'http://localhost:3005';

export const apiCall = async (endpoint, options = {}) => {
  const token =  localStorage.getItem('backend_jwt_token');
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, mergedOptions);
    
    if (!response.ok) {
      throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};

export const authAPI = {
  googleSignIn: async (googleToken) => {
    return apiCall('/api/auth/google-signin', {
      method: 'POST',
      body: JSON.stringify({ token: googleToken })
    });
  },
  
  guestLogin: async () => {
    return apiCall('/api/auth/guest-login', {
      method: 'POST'
    });
  },
  
  // Add other auth endpoints as needed
  logout: async () => {
    return apiCall('/api/auth/logout', {
      method: 'POST'
    });
  },
  
  getUserProfile: async () => {
    return apiCall('/api/auth/profile', {
      method: 'GET'
    });
  },
  
  updateProfile: async (profileData) => {
    return apiCall('/api/user/profile', {
      method: 'PUT',
      body: JSON.stringify(profileData)
    });
  },
  
  // Helper function to update both username and avatar in one call
  updateUsernameAndAvatar: async (username, avatarId) => {
    return apiCall('/api/user/profile', {
      method: 'PUT',
      body: JSON.stringify({ 
        username: username,
        avatarId: avatarId 
      })
    });
  },
  
  uploadBackground: async (file) => {
    // Create FormData for file upload
    const formData = new FormData();
    formData.append('image', file);
    
    // Get token for authorization
    const token = localStorage.getItem('backend_jwt_token');
    
    const response = await fetch(`${API_BASE_URL}/api/user/backgrounds`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        // Don't set Content-Type for FormData, let browser set it with boundary
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`Background upload failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  },
  
  getUserBackgrounds: async () => {
    // Get token for authorization
    const token = localStorage.getItem('backend_jwt_token');
    
    const response = await fetch(`${API_BASE_URL}/api/user/backgrounds`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`Failed to get backgrounds: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  }
};

export const roomAPI = {
  matchmaking: async () => {
    return apiCall('/api/rooms/matchmaking', {
      method: 'POST'
    });
  },
  
  getRoomInfo: async (roomId) => {
    return apiCall(`/api/rooms/${roomId}`, {
      method: 'GET'
    });
  },
  
  leaveRoom: async (roomId, reason = 'user-left') => {
    return apiCall(`/api/rooms/${roomId}/leave`, {
      method: 'POST',
      body: JSON.stringify({ reason })
    });
  },
  
  deleteRoom: async (roomId) => {
    return apiCall(`/api/rooms/${roomId}`, {
      method: 'DELETE'
    });
  }
};

const apiUtils = { apiCall, authAPI, roomAPI };
export default apiUtils;
